import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { BaseSchema } from 'yup';
import {
  CELLPHONE_FR_LENGTH_REGEX,
  CELLPHONE_FR_REGEX,
  CELLPHONE_UK_LENGTH_REGEX,
  CELLPHONE_UK_REGEX,
} from 'settings/regex';

export default (isUk: boolean, t: TFunction): BaseSchema =>
  Yup.object().shape({
    cellPhone: Yup.string().when('smsOptionField', {
      is: 'O',
      then: Yup.string()
        .required(t('LABEL_ERROR_CELLPHONE_REQUIRED', { ns: 'translation' }))
        .matches(
          isUk ? CELLPHONE_UK_LENGTH_REGEX : CELLPHONE_FR_LENGTH_REGEX,
          t('LABEL_ERROR_CELLPHONE_NUMBER_LENGTH', { ns: 'translation' })
        )
        .matches(
          isUk ? CELLPHONE_UK_REGEX : CELLPHONE_FR_REGEX,
          t('LABEL_ERROR_CELLPHONE_NUMBER_REGEX')
        ),
      otherwise: Yup.string()
        .matches(
          isUk ? CELLPHONE_UK_LENGTH_REGEX : CELLPHONE_FR_LENGTH_REGEX,
          t('LABEL_ERROR_CELLPHONE_NUMBER_LENGTH', { ns: 'translation' })
        )
        .matches(
          isUk ? CELLPHONE_UK_REGEX : CELLPHONE_FR_REGEX,
          t('LABEL_ERROR_CELLPHONE_NUMBER_REGEX')
        ),
    }),
    smsOptionField: Yup.string().test(
      'smsOptionField',
      t('LABEL_ERROR_AFIBEL_SMS_NEWSLETTER'),
      function (value) {
        const cellPhone: string = this.resolve(Yup.ref('cellPhone')) || '';

        return !cellPhone.trim() || !!value?.trim();
      }
    ),
  });
